<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
   viewBox="0 0 1920 103.3" enable-background="new 0 0 1920 103.3" xml:space="preserve" preserveAspectRatio="none">
    <path :fill="fillColor" d="M0,39.3c300.5,50.6,620.5,50.6,960,0s659.5-50.6,960,0v64H0V39.3z"/>
  </svg>
</template>
<script>
export default {
  name: 'svgDivider',
  props: {
    fillColor: {
      type: String,
      default: '#039be5',
      required: false
    }
  }
}
</script>
<style scoped lang="scss">
  svg{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    transform: translateY(-95%);
  }
</style>
